var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.clearCache}},[_c('v-icon',{attrs:{"size":"18"}},[_vm._v(" "+_vm._s(_vm.icons.mdiNuke)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }